/* eslint-disable ember/classic-decorator-hooks, ember/no-classic-components, ember/require-tagless-components, no-unused-vars, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { service } from '@ember/service';

import { isEmpty } from '@ember/utils';
import GoalState from '@linc-technologies/linced-common/enums/goal-state';

export default class TopicProgress extends Component {
  // Services
  @service
  store;

  @tracked categorySummary = null; // Initialize `categorySummary` to be null

  init() {
    super.init(...arguments);

    // Populate `categorySummary` asynchronously
    this.calculateSummary().then((summary) => {
      if (this.isDestroying || this.isDestroyed) {
        return;
      }
      this.categorySummary = summary;
    });
  }

  async calculateSummary() {
    let { personId, goals } = this;

    if (!personId || !goals) {
      return null;
    }

    let summary = {
      secure: 0,
      developing: 0,
      notSet: 0,
    };

    let promises = goals.map(async (goal) => {
      try {
        let states = await this.store.query('goals/state', {
          personId,
          goalId: goal.id,
          current: true,
        });

        if (states.length === 0) {
          // No state for this goal, default to 'notSet'
          summary.notSet++;
        } else {
          // Process existing states
          states.forEach((state) => {
            if (state.awarded === GoalState.NOT_SET) {
              summary.notSet++;
            } else if (state.awarded === GoalState.DEVELOPING) {
              summary.developing++;
            } else if (state.awarded === GoalState.SECURE) {
              summary.secure++;
            }
          });
        }
      } catch (error) {
        // Handle errors in querying states if necessary
        summary.notSet++; // Default to 'notSet' if an error occurs
      }
    });

    // Wait for all promises to resolve
    await Promise.all(promises);

    return summary;
  }

  // chartData generates the required chart formatted data.
  get chartData() {
    let data = [];
    const placeholder = {
      value: 'unset',
      tooltip: 'Not set',
      count: 1,
      color: '#e0e0e0',
    };

    let summary = this.categorySummary;
    if (isEmpty(summary)) {
      // No data - return a dummy entry so that a chart is still generated
      data.push(placeholder);
      return data;
    }

    if (summary.secure) {
      data.push({
        value: 'secure',
        tooltip: 'Secure',
        count: summary.secure,
        color: '#66bb6a',
      });
    }

    if (summary.developing) {
      data.push({
        value: 'developing',
        tooltip: 'Developing',
        count: summary.developing,
        color: '#ffecb3',
      });
    }

    if (summary.notSet) {
      data.push({
        value: 'unset',
        tooltip: 'Not set',
        count: summary.notSet,
        color: '#e0e0e0',
      });
    }

    return data;
  }
}
